import { useNavigate } from 'react-router';
import Stack from '@mui/material/Stack';
import { JuicyTypography } from '../../components/index.ts';
import { Button } from '../../components/button/index.ts';
import { RippleWaves } from '../../features/index.ts';
import { DoneIcon } from '../../assets/icons/done.tsx';
import { Path } from '../../assets/enums/index.ts';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { buttonSx, wrapperSx } from './styles.ts';
import { useTheme } from '@mui/material';
import { useEffect } from 'react';

export const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const { gameSessionParams } = useGameSessionContext();
  const theme = useTheme();
  useEffect(() => {
    setTimeout(() => navigate(Path.StartGame), 2000);
  }, []);
  return (
    <Stack sx={wrapperSx(theme)}>
      <Stack
        component={Button}
        variantStyle={'secondary'}
        active={true}
        sx={buttonSx}>
        <DoneIcon />
        <RippleWaves width={480} height={480} />
      </Stack>
      <JuicyTypography mt={18}>Payment successful</JuicyTypography>
      <JuicyTypography mt={4} variantStyle={'orange'}>${gameSessionParams.amountWithDiscountOrAmount}</JuicyTypography>
    </Stack>
  );
};
